import { Pipe, PipeTransform } from '@angular/core'
import { SelectOption } from '@mmx/shared'
import { TranslateService } from '@ngx-translate/core'

@Pipe({
  name: 'viewValue',
  pure: true,
  standalone: false,
})
export class ViewValuePipe<T> implements PipeTransform {
  constructor(
    private translate: TranslateService,
  ) { }
  public transform(input: string | string[], options: SelectOption<T>[], delimiter = ', '): string {
    const getViewValue = (i: string) => {
      const option = options.find((opt) => opt.value === i)

      return option ? this.translate.instant(option.viewValue) : i
    }

    if (Array.isArray(input)) {
      return input.map((i) => getViewValue(i)).join(delimiter)
    }

    return getViewValue(input)
  }
}
